<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#ff4343" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left py-2>
        <span
          style="font-family: opensansbold; font-size: 14px; color: #808080"
        >
          Top Selling Products
        </span>
      </v-flex>
      <v-flex xs12 py-2 v-for="(item, i) in storage" :key="i">
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <v-layout px-4 wrap justify-center>
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs3 sm2 pa-2 align-self-center>
                  <v-img
                    :src="mediaURL + item._id.photos[0]"
                    height="80px"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF4343"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex pt-4 xs9 sm10 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm8>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span style="cursor: pointer;" @click="checkProduct(item._id._id)">
                            <span
                              style="
                                font-family: opensansbold;
                                font-size: 16px;
                                color: #808080;
                              "
                            >
                              {{ item._id.productname.slice(0, 40) }}
                              <span v-if="item._id.productname.length > 40">
                                ...
                              </span>
                            </span>
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            Price: ₹{{ item._id.offerPrice }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Sale
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            ₹{{ item.totalAmount }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Today
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            ₹{{ item.today }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex> -->
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Item Sold
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            {{ item.productCount }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      showSnackBar: false,
      msg: "",
      timeout: 5000,
    };
  },
  methods: {
    checkProduct(id) {
      axios({
        method: "POST",
        url: "product/view",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status === false) {
            this.msg = "Faild to find the product";
            this.showSnackBar = true;
          } else {
            this.$router.push("/Seller/Product/" + id);
          }
        })
        .catch((err) => {
          this.$router.push("/ServerError");
          console.log(err);
        });
    },
  },
};
</script>
